import React, { useEffect, useMemo, useState } from 'react';
import { MusicEntity } from '~/features/dashboard/store/models';
import { useParams, useRouteMatch } from 'react-router-dom';
import { MusicApi } from '~/api/music.api';
import { fakeMusic } from '~/mock/fakeMusic';
import { notifyError } from '~/common/notifications';
import { Loader } from '~/common/loader';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { axiosInstance } from '~/api/config/axios.config';
import { SongDetailsComponent } from '~/features/dashboard/components/song-details/coponents/SongDetailsComponent';
import { getTagListings } from '~/features/dashboard/store/actions.thunks';
import { useThunkDispatch } from '~/utils/hooks/useThunkDispatch';

export const SongDetails: React.FC = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [songDetails, setSongDetails] = useState<MusicEntity>();
    const match = useRouteMatch<{ creatorId: string }>();
    const creatorId = useMemo(() => Number(match.params.creatorId), [match.params.creatorId]);
    const { songId } = useParams<{ songId: string }>();
    const [tagDetails, setTagDetails] = useState([]);
    const dispatch = useThunkDispatch();

    useEffect(() => {
        onLinkDeal(1, 2);
        axiosInstance.get('/Catalogue/projectcreator/songtagslist', { params: { gsongRef: songId, projectId: creatorId } }).then(({ data }) => {
            setTagDetails(data);
        });
        dispatch(getTagListings());
    }, [songId, creatorId]); // eslint-disable-line

    const deleteAssetsBtn = async (value: any) => {
        let assetId: any = value.id;
        let data: any = [...tagDetails];
        let data1: any = await removeByAttr(data, 'id', assetId);
        await setTagDetails(data1);
        await axiosInstance.delete(`catalogue/projectCreator/songtags/delete/${assetId}`);
    };

    const downloadImage = async (img: string, type: any) => {
        const response = await fetch(img);
        if (response.status === 200) {
            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = type === 'audio' ? 'track' : 'image';
            document.body.appendChild(link);
            link.click();
            link.remove();
            return { success: true };
        }
    };

    var removeByAttr = function (arr: any, attr: any, value: any) {
        var i = arr.length;
        while (i--) {
            if (arr[i] && arr[i].hasOwnProperty(attr) && arguments.length > 2 && arr[i][attr] === value) {
                arr.splice(i, 1);
            }
        }
        return arr;
    };

    const onLinkDeal = (data: any, type: any) => {
        if (songId) {
            if (type !== 'link' && type !== 'unlink') {
                setIsLoading(true);
            }
            MusicApi.getMusicDetail(songId)
                .then(({ songDetail, songDeals, gSongNotesEntry, songProjectTrack }) => {
                    const newSongDetails: MusicEntity = {
                        ...fakeMusic,
                        id: songDetail.assetCode,
                        dealDeliveredTo: songDetail.gSongFirstDeal,
                        label: songDetail.label,
                        ISRC: songDetail.isrc,
                        UPC: songDetail.upc,
                        meta: {
                            ...fakeMusic.meta,
                            title: songDetail.songName,
                            artist: songDetail.songArtist,
                            artistImage: songDetail.songArtistImage ? process.env.REACT_APP_ASSET + songDetail.songArtistImage : '',
                            featArtists: [songDetail?.gSongFeatArtist1, songDetail?.gSongFeatArtist2, songDetail?.gSongFeatArtist3].filter(el => el !== ''),
                        },
                        keyDates: gSongNotesEntry,
                        releaseDate: songDetail.releaseDate || null,
                        dates: [
                            {
                                title: 'Release date',
                                date: '',
                            },
                        ],
                        neighbouringRights: songDetail.isNBREligible,
                        otherEligible: songDetail.isOtherEligible,
                        publishing: songDetail.isPubEligible,
                        masters: songDetail.isRecEligible,
                        writerShareEligible: songDetail.isWriterShareEligible,
                        connectedDeals: songDeals,
                        songProjectTrack: songProjectTrack,
                        gMyWriterName: songDetail.gMyWriterName,
                        gPublisherName: songDetail.gPublisherName,
                        writingShare: songDetail.writingShare,
                        publishingShare: songDetail.publishingShare,
                    };
                    setSongDetails(newSongDetails);
                })
                .catch(e => {
                    notifyError({
                        title: 'Error',
                        message: e.message || e.toString(),
                    });
                })
                .finally(() => {
                    setIsLoading(false);
                });
        } else {
            notifyError({
                title: 'Error',
                message: 'No Song ID',
            });
        }
    };

    if (!songDetails) {
        return null;
    }
    return isLoading ? (
        <Loader />
    ) : (
        <SongDetailsComponent
            tagDetails={tagDetails}
            song={songDetails}
            onLinkingDeal={onLinkDeal}
            downloadImage={downloadImage}
            deleteAssetsBtn={deleteAssetsBtn}
        />
    );
};
